<template>
  <div class="date-range-presets">
    <button
      v-for="preset of PRESETS"
      :key="preset.id"
      :class="{ active: isPresetActive(preset.id) }"
      type="button"
      tabindex="-1"
      @click="$emit('select', calculatePresetRange(preset.id))"
    >
      {{ preset.label }}
    </button>
  </div>
</template>

<style lang="scss" src="./VDateRangePresets.scss" />

<script lang="ts">
import DateRange from '@/core/types/DateRange';
import type { UnwrapNestedRefs } from "vue";

type PresetId = 'today' | 'yesterday' | 'thisWeek' | 'lastWeek' | 'thisMonth' | 'lastMonth';

const PRESETS: { label: string; id: PresetId }[] = [
  { label: "Сегодня",        id: "today"     },
  { label: "Вчера",          id: "yesterday" },
  { label: "Эта неделя",     id: "thisWeek"  },
  { label: "Прошлая неделя", id: "lastWeek"  },
  { label: "Этот месяц",     id: "thisMonth" },
  { label: "Прошлый месяц",  id: "lastMonth" },
];

export default defineComponent({
  name: "VDateRangePresets",

  props: {
    range: {
      type:    Object as PropType<DateRange | UnwrapNestedRefs<DateRange>>,
      default: null,
    },
  },

  emits: ['select'],

  setup() {
    return { PRESETS };
  },

  methods: {
    isPresetActive(id: PresetId): boolean {
      const dateFrom = this.range?.start ?? null;
      const dateTo   = this.range?.end ?? null;
      if (dateFrom === null || dateTo === null) return false;

      const presetRange = this.calculatePresetRange(id);
      return this.$core.utils.date.format(dateFrom) === this.$core.utils.date.format(presetRange.start)
        && this.$core.utils.date.format(dateTo) === this.$core.utils.date.format(presetRange.end);
    },

    calculatePresetRange(id: PresetId): DateRange {
      const today = new Date();
      let dateFrom: Date;
      let dateTo:   Date;

      switch (id) {
        case "today":
          dateFrom = dateTo = today;
          break;
        case "yesterday":
          today.setDate(today.getDate() - 1);
          dateFrom = dateTo = today;
          break;
        case "thisWeek":
          dateFrom = this.$core.utils.date.getCurrentWeekStartDate();
          dateTo   = new Date(dateFrom);
          dateTo.setDate(dateTo.getDate() + 6);
          break;
        case "lastWeek":
          dateFrom = this.$core.utils.date.getCurrentWeekStartDate();
          dateFrom.setDate(dateFrom.getDate() - 7);
          dateTo   = new Date(dateFrom);
          dateTo.setDate(dateTo.getDate() + 6);
          break;
        case "thisMonth":
          dateFrom = new Date(today.getFullYear(), today.getMonth(), 1);
          dateTo   = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          break;
        case "lastMonth":
          dateFrom = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          dateTo   = new Date(today.getFullYear(), today.getMonth(), 0);
          break;
      }

      return new DateRange(dateFrom, dateTo);
    },
  },
});
</script>
